<!--
 * @Description:
 * @Author: muqingkun
 * @Date: 2023-07-27 16:38:45
 * @LastEditTime: 2024-05-10 17:22:53
 * @LastEditors: Please set LastEditors
 * @Reference:
-->
<template>
  <div class="tags_input">
    <el-scrollbar
      @click="focusNewTag()"
      v-click-outside="closeContextMenu"
      :class="{
        'v3ti--focus': isInputActive,
        'v3ti--error': isError
      }"
      class="v3ti"
    >
      <div class="v3ti-content" ref="inputBox">
        <span v-for="(tag, index) in innerTags" :key="index" class="v3ti-tag">
          <slot
            v-if="isShot('item')"
            name="item"
            v-bind="{ name: tag, index, tag }"
          />
          <span v-else class="v3ti-tag-content"> {{ tag }} </span>
          <a
            v-if="!readOnly"
            @click.prevent.stop="remove(index)"
            class="v3ti-remove-tag"
          />
        </span>
        <textarea
          ref="inputTag"
          :placeholder="innerTags.length > 0 ? '' : placeholder"
          v-model="newTag"
          @keydown.delete.stop="removeLastTag"
          @keydown="addNew"
          @blur="handleInputBlur"
          @focus="handleInputFocus"
          @input="makeItNormal"
          class="v3ti-new-tag"
          :disabled="readOnly"
        />
        <el-button
          v-show="isInputActive"
          link
          class="delete-btn"
          @click.stop="clear"
          ><el-icon><Delete /></el-icon
        ></el-button>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3';

export default {
  name: 'Vue3TagsInput',
  emits: [
    'update:modelValue',
    'update:tags',
    'on-limit',
    'on-tags-changed',
    'on-remove',
    'on-error',
    'on-focus',
    'on-blur',
    'on-new-tag'
  ],
  props: {
    readOnly: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: String,
      default: ''
    },
    validate: {
      type: [String, Function, Object],
      default: ''
    },
    addTagOnReg: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop, no-useless-escape
      default: /\,|\s|\n/
    },
    addTagOnKeys: {
      type: Array,
      default: function () {
        return [
          13, // Enter
          ',', // Comma ','
          32 // Space
        ];
      }
    },
    placeholder: {
      type: String,
      default: ''
    },
    tags: {
      type: [Array, String],
      default: () => []
    },
    delimiter: {
      // 给服务端的数据 分割符
      type: String,
      default: 'Array'
    },
    loading: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: -1
    },
    allowDuplicates: {
      type: Boolean,
      default: false
    },
    addTagOnBlur: {
      type: Boolean,
      default: true
    },
    duplicateSelectItem: {
      type: Boolean,
      default: true
    }
  },
  components: {},
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      isInputActive: false,
      isError: false,
      newTag: '',
      innerTags: [],
      multiple: false
    };
  },
  computed: {
    isLimit() {
      const isLimit =
        this.limit > 0 && Number(this.limit) === this.innerTags.length;
      if (isLimit) {
        this.$emit('on-limit');
      }
      return isLimit;
    }
  },
  watch: {
    error() {
      this.isError = this.error;
    },
    modelValue: {
      immediate: true,
      handler(value) {
        this.newTag = value;
      }
    },
    tags: {
      deep: true,
      immediate: true,
      handler(tags) {
        if (this.delimiter !== 'Array' && typeof tags === 'string') {
          this.innerTags = tags !== '' ? tags.split(this.delimiter) : [];
        } else {
          this.innerTags = [...tags];
        }
      }
    }
  },
  methods: {
    isShot(name) {
      return !!this.$slots[name];
    },
    makeItNormal(event) {
      this.$emit('update:modelValue', event.target.value);
      this.$refs.inputTag.className = 'v3ti-new-tag';
      this.$refs.inputTag.style.textDecoration = 'none';
    },
    resetData() {
      this.innerTags = [];
    },
    resetInputValue() {
      this.newTag = '';
      this.$emit('update:modelValue', '');
    },
    closeContextMenu() {
      this.isInputActive = false;
    },

    focusNewTag() {
      if (this.readOnly || !this.$el.querySelector('.v3ti-new-tag')) {
        return;
      }
      this.$el.querySelector('.v3ti-new-tag').focus();
    },

    handleInputFocus(event) {
      this.isInputActive = true;
      this.$emit('on-focus', event);
    },
    handleInputBlur(e) {
      this.addNew(e);
      this.$emit('on-blur', e);
    },
    addNew(e) {
      const keyShouldAddTag = e
        ? this.addTagOnKeys.indexOf(e.keyCode) !== -1 ||
          this.addTagOnKeys.indexOf(e.key) !== -1
        : true;
      if (e.keyCode === 86 && e.ctrlKey) {
        setTimeout(() => {
          const reg = new RegExp(this.addTagOnReg, 'g');
          const newTagList = Array.from(this.newTag.split(reg));
          newTagList.forEach(item => {
            if (
              this.innerTags.indexOf(item) === -1 &&
              this.validateIfNeeded(this.newTag)
            ) {
              this.innerTags.push(item);
            } else {
              this.makeItError(true);
            }
          });
          this.resetInputValue();
          this.tagChange();
        }, 10);
      }
      const typeIsNotBlur = e && e.type !== 'blur';
      if ((!keyShouldAddTag && typeIsNotBlur) || this.isLimit) {
        return;
      }
      if (
        this.newTag &&
        (this.allowDuplicates || this.innerTags.indexOf(this.newTag) === -1) &&
        this.validateIfNeeded(this.newTag)
      ) {
        this.innerTags.push(this.newTag);
        this.resetInputValue();
        this.tagChange();
        e && e.preventDefault();
      } else {
        if (this.validateIfNeeded(this.newTag)) {
          this.makeItError(true);
        } else {
          this.makeItError(false);
        }
        e && e.preventDefault();
      }
    },
    makeItError(isDuplicatedOrMaxLength) {
      if (this.newTag !== '') {
        this.$refs.inputTag.className = 'v3ti-new-tag v3ti-new-tag--error';
        this.$refs.inputTag.style.textDecoration = 'underline';
        this.$emit('on-error', isDuplicatedOrMaxLength);
      }
    },
    validateIfNeeded(tagValue) {
      if (this.validate === '' || this.validate === undefined) {
        return true;
      }
      if (typeof this.validate === 'function') {
        return this.validate(tagValue);
      }
      return true;
    },
    removeLastTag() {
      if (this.newTag) {
        return;
      }
      this.innerTags.pop();
      this.tagChange();
    },
    remove(index) {
      this.innerTags.splice(index, 1);
      this.tagChange();
      this.$emit('on-remove', index);
    },
    clear() {
      this.innerTags = [];
      this.tagChange();
    },
    tagChange() {
      let tags =
        this.delimiter !== 'Array'
          ? this.innerTags.join(this.delimiter)
          : this.innerTags;
      // 过滤空数值
      tags = tags.filter(item => item);
      this.$emit('on-tags-changed', tags);
      this.$emit('update:tags', tags);
    }
  }
};
</script>

<style lang="scss">
$errorColor: var(--el-color-error);
$primaryColor: var(--el-color-primary-light-9);
$paddingItem: 4px 7px;
$marginTag: 3px;
$paddingTag: 5px;
.tags_input {
  z-index: 3;
  position: relative;
  width: 100% !important;
  height: 32px;
}
.v3ti {
  padding: 2px 10px 2px 2px;
  position: absolute;
  top: 0;
  height: 32px;
  overflow-y: auto;
  box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color))
    inset;
  width: 100% !important;
  border-radius: 8px;
  min-height: 32px;
  line-height: 1.4;
  background-color: #fff;
  cursor: text;
  text-align: left;
  -webkit-appearance: textfield;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  &:hover {
    box-shadow: 0 0 0 1px var(--el-text-color-disabled) inset;
  }

  &--focus {
    outline: 0;
    height: 100px !important;
    box-shadow: 0 0 0 1px var(--el-color-primary) inset !important;
  }

  &--error {
    border-color: $errorColor;
  }

  .v3ti-no-data {
    color: #d8d8d8;
    text-align: center;
    padding: $paddingItem;
  }

  .v3ti-loading {
    padding: $paddingItem;
    text-align: center;
  }

  .v3ti-content {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding-right: 10px;
    .delete-btn {
      position: absolute;
      right: 6px;
      top: calc(50% - 7px);
      &:hover {
        color: var(--el-color-primary);
      }
    }
  }

  .v3ti-tag {
    display: flex;
    font-weight: 400;
    margin: $marginTag;
    padding: 0 $paddingTag;
    background: $primaryColor;
    color: var(--el-color-primary);
    height: 22px;
    border-radius: 5px;
    align-items: center;
    max-width: calc(100% - (($marginTag * 2) + ($paddingTag * 2)));
    .v3ti-tag-content {
      flex: 1;
      min-width: 1px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .v3ti-remove-tag {
      color: var(--el-color-primary);
      transition: opacity 0.3s ease;
      opacity: 0.5;
      cursor: pointer;
      padding: 0 5px 0 7px;

      &::before {
        content: 'x';
      }

      &:hover {
        opacity: 1;
      }
    }
  }

  .v3ti-new-tag {
    background: transparent;
    border: 0;
    font-weight: 400;
    margin: 3px;
    outline: none;
    padding: 0 4px;
    flex: 1;
    min-width: 60px;
    height: 22px;
    resize: none;

    &--error {
      color: $errorColor;
    }
  }
}
</style>
